module.exports = __webpack_public_path__ + "static/815-ad68c6f66c12d0b434ed2088d2f5e353.jpg";